<template>
<div class="sidepanel">

  <nav class="panel">

    <!-- <p class="panel-heading my-panel-heading" style="background: darkgreen; color: red"  @click="navigateTo('profile')">
      <span class="panel-icon">
        <i class="fas fa-id-card" style="color: white" aria-hidden="true"></i>
      </span>
      môj profil
    </p> -->

    <p class="panel-heading my-panel-heading" style="background: lightgrey"  >
      <!-- <span class="panel-icon">
        <i class="fas fa-trophy" style="color: gold" aria-hidden="true"></i>
      </span> -->
      <b-icon
                pack="fas"
                icon="trophy"
                size="is-small"
                type="is-gold">
            </b-icon>
    </p>

    <a class="panel-block my-panel-block" @click="navigateTo('profile')">
    <span class="panel-icon">
      <i class="fas fa-id-card" style="color: white" aria-hidden="true"></i>
    </span>
    <span>MÔJ PROFIL</span>
    </a>


    <a class="panel-block my-panel-block" @click="navigateTo('dashboard')">
    <span class="panel-icon">
      <i class="fas fa-chart-line" style="color: white" aria-hidden="true"></i>
    </span>
    DASHBORD
<!--      <router-link to="/user/xxx/dashboard">DASHBOARD</router-link>-->
    </a>
    <a class="panel-block my-panel-block" @click="navigateTo('activity')">
    <span class="panel-icon">
      <i class="fas fa-cog" style="color: white" aria-hidden="true"></i>
    </span>
      AKTIVITY
<!--      <router-link to="/user/xxx/activity">AKTIVITY</router-link>-->
    </a>
    <a class="panel-block my-panel-block" @click="navigateTo('topten')">
    <span class="panel-icon">
      <i class="fas fa-trophy" style="color: white" aria-hidden="true"></i>
    </span>
      TOP 10
<!--      <router-link to="/user/xxx/topten">TOP 10</router-link>-->
    </a>
    <a class="panel-block my-panel-block" @click="navigateTo('calendar')">
    <span class="panel-icon">
      <i class="fas fa-calendar" style="color: white" aria-hidden="true"></i>
    </span>
      KALENDÁR
<!--      <router-link to="/user/xxx/calendar">KALENDÁR</router-link>-->
    </a>
    <a class="panel-block my-panel-block" @click="navigateTo('contact')">
    <span class="panel-icon">
      <i class="fas fa-id-card" style="color: white" aria-hidden="true"></i>
    </span>
      KONTAKTY
<!--      <router-link to="/user/xxx/contact">KONTAKTY</router-link>-->
    </a>

    ------

    <a class="panel-block my-panel-block" @click="navigateTo('purchase')">
    <span class="panel-icon">
      <i class="fas fa-id-card" style="color: white" aria-hidden="true"></i>
    </span>
      Purchases
<!--      <router-link to="/user/xxx/contact">KONTAKTY</router-link>-->
    </a>

    <a class="panel-block my-panel-block" @click="navigateTo('googlecontact')">
    <span class="panel-icon">
      <i class="fas fa-id-card" style="color: white" aria-hidden="true"></i>
    </span>
      Google
<!--      <router-link to="/user/xxx/contact">KONTAKTY</router-link>-->
    </a>


<!--    <div class="panel-block">-->
<!--      <button class="button is-link is-outlined is-fullwidth">-->
<!--        reset all filters-->
<!--      </button>-->
<!--    </div>-->
  </nav>

</div>
</template>

<script>
  export default {
    name: 'SideMenu',
    methods: {
      navigateTo (routepath) {
        // window.alert(this.msg)
        this.$router.push({path: "/main/"+routepath})
      }
    }

  }
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*.sidepanel {*/
  /*  margin: 40px 0 0;*/
  /*  background: red;*/
  /*}*/
  .panel-block {
    border: none;
    font-weight: 800;
    /*color: white;*/
  }
  a {
    color: white;
  }
  .my-panel-heading {
    background-color: none;
    /* padding-left: 10%; */
  }

  /* .my-panel-block {
    padding-left: 10%;
  } */

  /* .column {
    padding: 0
  } */
  .sidepanel {
    margin-left: 0.5em;
    /* margin-right: 0.5em; */
  }
  .panel {
    margin-left: 0.5em;
    /* margin-right: 0.5em; */
  }
</style>
